import { postcodeIsValid } from '@at/formatter-utils';
import { getItemLocalStorage, setItemLocalStorage } from '@at/window-utils';
import { USER_LOCATION_POSTCODE_STORAGE_KEY } from '@at/window-utils';
import Cookies from 'js-cookie';
import { useLocation, useHistory } from 'react-router';
import { useSearchFields } from './search-fields';
import { Channel } from '@at/sauron-platform-core/lib/types';
import { parse, stringify } from 'query-string';
const getPostcodeFromLocalStorage = () => {
    return getItemLocalStorage(USER_LOCATION_POSTCODE_STORAGE_KEY) || '';
};
const setPostcodeInLocalStorage = (postcode) => {
    setItemLocalStorage(USER_LOCATION_POSTCODE_STORAGE_KEY, postcode);
};
const getPostcodeFromCookie = () => {
    const postcodeValue = !!Cookies.get('postcode') && Cookies.get('postcode');
    return (postcodeValue && postcodeValue.split('=').pop()) || '';
};
const setPostcodeInCookie = (postcode) => {
    Cookies.set('postcode', `postcode=${postcode}`);
};
const getPostcodeFromQueryParams = (search) => {
    const queryParams = parse(search);
    const { postcode } = queryParams || {};
    if (!postcode) {
        return '';
    }
    return Array.isArray(postcode) ? String(postcode[0]) : String(postcode);
};
const updateQueryParams = (postcode, search, history) => {
    const queryParams = parse(search);
    queryParams['postcode'] = postcode;
    history.push({ search: `?${stringify(queryParams)}` });
};
export const usePostcode = (channel = Channel.cars, condition = 'used') => {
    const { searchFields, updatePostcodeSearchFields } = useSearchFields(channel, condition);
    const { search } = useLocation();
    const history = useHistory();
    const postcode = getPostcodeFromQueryParams(search) ||
        getPostcodeFromLocalStorage() ||
        searchFields.postcode ||
        getPostcodeFromCookie();
    const updatePostcode = (postcode) => {
        if (postcodeIsValid(postcode)) {
            updateQueryParams(postcode, search, history);
            setPostcodeInCookie(postcode);
            setPostcodeInLocalStorage(postcode);
            updatePostcodeSearchFields(postcode);
        }
    };
    return { postcode, updatePostcode };
};
